
<script>
   export let heading;
   export let items;
   export let color;

   import TestItem from './TestItem.svelte';

   var pointsSum = 0;
   function countUp(n) {
      pointsSum += n;
      return n;
   }
</script>

<section class='card shadow-lg' style='--color : var(--{color});'>
   <div class="card-header">
      <h2 class="card-title">{heading}</h2>
    </div>
    <div class="card-body slim">
      <small class="card-text opacity-75 fw-light float-end">{pointsSum} points</small>
      <small class="card-text">{items.length} Items</small>
    </div>
    <ul class="list-group list-group-flush">
      {#each items as item}
         <TestItem ident={item.ident} main={item.main} pointsValue={countUp(item.points)} prerequisitesPolicy={item.prerequisitesPolicy}/>
      {/each}
    </ul>
</section>

<style>
   section.card {
      background: var(--color);
   }
   section.card > .card-header {
      color: white;
   }
   section.card :global(li.list-group-item) {
      color: var(--color) !important;
   }
</style>
